var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-in-page',{attrs:{"credentials":_vm.data,"errors":_vm.errors,"wait":_vm.wait},on:{"update:email":function($event){_vm.data.email = $event},"update:password":function($event){_vm.data.password = $event},"submit":_vm.signIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }